import { TeacherHomeScreen } from "../../features/home";

/** FS-01-04 교사 홈 — 페이지는 조립만 한다(CSG 4.2). 화면 본체는 features/home */
export default function TeacherHomePage() {
  return <TeacherHomeScreen />;
}
